import { render, staticRenderFns } from "./InfoForm.vue?vue&type=template&id=bc7b5e4e&scoped=true"
import script from "./InfoForm.vue?vue&type=script&lang=js"
export * from "./InfoForm.vue?vue&type=script&lang=js"
import style0 from "./InfoForm.vue?vue&type=style&index=0&id=bc7b5e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7b5e4e",
  null
  
)

export default component.exports